import { render, staticRenderFns } from "./PartnerNew.vue?vue&type=template&id=7fc18c48&"
import script from "./PartnerNew.vue?vue&type=script&lang=js&"
export * from "./PartnerNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc18c48')) {
      api.createRecord('7fc18c48', component.options)
    } else {
      api.reload('7fc18c48', component.options)
    }
    module.hot.accept("./PartnerNew.vue?vue&type=template&id=7fc18c48&", function () {
      api.rerender('7fc18c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/PartnerNew.vue"
export default component.exports